import { useState, type FormEvent } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { Link, useNavigate } from 'react-router-dom'
import { signIn } from '../../api/owner'
import {
  AuthError,
  AuthField,
  AuthFields,
  AuthHeading,
  AuthShell,
  AuthSocial,
  AuthSubmit,
  AuthSwitch,
  authInputClass,
  authLinkClass,
} from './AuthShell'

/** Ronde 21A en 21C — aanmelden. */
export function SignInPage() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function submit(event: FormEvent) {
    event.preventDefault()
    setBusy(true)
    setError(null)

    try {
      await signIn(email.trim(), password)
      // De sessiecookie staat er nu; OwnerGate moet opnieuw kijken wie we zijn.
      await queryClient.invalidateQueries({ queryKey: ['owner'] })
      navigate('/beheer')
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'Aanmelden lukte niet.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <AuthShell>
      <form onSubmit={(event) => void submit(event)} className="mt-9 lg:mt-0">
        <AuthHeading title="Welkom terug">Meld je aan om je events te beheren.</AuthHeading>

        <AuthFields>
          <AuthField id="email" label="E-mail">
            <input
              id="email"
              type="email"
              autoComplete="username"
              autoFocus
              placeholder="lotte@voorbeeld.be"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              className={authInputClass}
            />
          </AuthField>

          <AuthField
            id="password"
            label="Wachtwoord"
            action={
              <Link to="/beheer/wachtwoord-vergeten" className={`text-[13px] ${authLinkClass}`}>
                Vergeten?
              </Link>
            }
          >
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className={`${authInputClass} tracking-[0.2em]`}
            />
          </AuthField>

          <AuthSubmit busy={busy} disabled={!email.trim() || !password}>
            Aanmelden
          </AuthSubmit>

          <AuthSocial />
        </AuthFields>

        {error && <AuthError>{error}</AuthError>}

        <AuthSwitch question="Nog geen account?">
          <Link to="/beheer/registreren" className={authLinkClass}>
            Registreren
          </Link>
        </AuthSwitch>
      </form>
    </AuthShell>
  )
}
